import type { DreamRenderElementProps } from '@/types';

import { ImageElement } from '../../imageElement/Image';
import type { TImageElement } from '../../imageElement/Image.types';
import { YouTubePlayButton } from '../YouTubePlayButton';

interface Props {
  node: TImageElement;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showPlayButton?: boolean;
  srcSet?: string;
  sizes?: string;
  attributes?: DreamRenderElementProps<TImageElement>['attributes'];
}

export const YoutubeImageItem = ({ node, onClick, showPlayButton, srcSet, sizes, attributes }: Props) => {
  const renderedChildren = (
    <>
      <ImageElement
        element={{
          ...node,
          attrs: {
            ...node.attrs,
            alt: 'YouTube Thumbnail',
            className: 'w-full h-auto',
            aspectRatio: node.attrs?.aspectRatio ?? '16/9',
            objectFit: node.attrs?.objectFit ?? 'cover',
            srcSet,
            sizes,
          },
        }}
      />
      {showPlayButton && <YouTubePlayButton />}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className="relative" onClick={onClick} {...attributes}>
        {renderedChildren}
      </button>
    );
  }

  return (
    <div className="relative" {...attributes}>
      {renderedChildren}
    </div>
  );
};
